"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SubdirectoryArrowLeft_exports = {};
__export(SubdirectoryArrowLeft_exports, {
  default: () => SubdirectoryArrowLeft_default
});
module.exports = __toCommonJS(SubdirectoryArrowLeft_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.51172 13.5898L9.42578 15.4844C9.58203 15.6536 9.66016 15.8555 9.66016 16.0898C9.66016 16.3112 9.58203 16.5065 9.42578 16.6758C9.25651 16.832 9.05469 16.9102 8.82031 16.9102C8.59896 16.9102 8.40365 16.832 8.23438 16.6758L4.91406 13.3359C4.74479 13.1797 4.66016 12.9844 4.66016 12.75C4.66016 12.5156 4.74479 12.3203 4.91406 12.1641L8.23438 8.82422C8.40365 8.66797 8.59896 8.58984 8.82031 8.58984C9.05469 8.58984 9.25651 8.66797 9.42578 8.82422C9.58203 8.99349 9.66016 9.19531 9.66016 9.42969C9.66016 9.65104 9.58203 9.84635 9.42578 10.0156L7.51172 11.9102H13C13.6901 11.9102 14.276 11.6693 14.7578 11.1875C15.2526 10.6927 15.5 10.1003 15.5 9.41016V4.41016C15.5 4.1888 15.5781 4 15.7344 3.84375C15.9036 3.67448 16.1055 3.58984 16.3398 3.58984C16.5612 3.58984 16.75 3.67448 16.9062 3.84375C17.0755 4 17.1602 4.1888 17.1602 4.41016V9.41016C17.1602 9.99609 17.056 10.5365 16.8477 11.0312C16.6263 11.5391 16.3268 11.9818 15.9492 12.3594C15.5716 12.737 15.1289 13.0365 14.6211 13.2578C14.1133 13.4792 13.5729 13.5898 13 13.5898H7.51172Z",
      fill: "currentColor"
    }
  )
);
const SvgSubdirectoryArrowLeft = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var SubdirectoryArrowLeft_default = SvgSubdirectoryArrowLeft;
